<ui-section class="cursor-hand width-100 height-100" (click)="goToNext(tileData)">
    <ui-section-content>
        <div class="title-row">
            <edit-text
                [disabled]="!(tileConfig.hasTileAdminAccess$ | async)"
                [(ngModel)]="tileData.name"
                (ngModelChange)="updateTileName()"
            />
            <div class="action-buttons">
                @if (tileConfig.hasTileAdminAccess$ | async) {
                    <ui-icon-button iconName="delete" size="small" (click)="deleteTile($event)" />
                }
            </div>
        </div>

        @if (!(areSensorsLoading$ | async)) {
            <div class="grid-container grid-1 sensors-grid">
                @for (sensorDescription of tileData.description.sensors; track sensorDescription) {
                    @if (sensorDescription.sensorIdentifier | sensor; as sensor) {
                        <div class="sensor-line">
                            <img class="universe-picture" [src]="sensor.universeId | universeImage: 'standalone'" />
                            <div class="sensor-gauge">
                                <div class="sensor-gauge-header">
                                    <span>
                                        {{ sensor.name }}
                                    </span>
                                    <span class="value" [coloredTextColor]="getValueColor(sensorDescription, sensor)">
                                        {{ getSensorValue(sensorDescription, sensor) | localnumber }}&nbsp;{{
                                            sensor.displayedUnitMeasureCode | referenceListLabel: 'unit'
                                        }}
                                    </span>
                                </div>
                                <flat-gauge
                                    trackHeight="5px"
                                    class="flat-gauge"
                                    [trackMin]="getTrackMin(sensorDescription)"
                                    [trackMax]="getTrackMax(sensorDescription)"
                                    [markers]="getMarkers(sensorDescription, sensor)"
                                />
                            </div>
                        </div>
                    }
                }
            </div>
        } @else {
            <loading-and-error [isLoading]="true" />
        }
    </ui-section-content>
</ui-section>
